import { Route } from 'react-router';
import { OrganizationDetailsPage } from '../OrganizationDetailsPage';
import { BillingPage } from '../_BillingPage/BillingPage';
import { OrganizationUserDetailsPage } from '../_OrganizationUserDetailsPage/OrganizationUserDetailsPage';
import { getMasterAdminOrganizationDetailsPath } from '../path/path';
import { getMasterAdminBillingPath } from '../_BillingPage/path/path';
import { getMasterAdminOrganizationUserDetailsPath } from '../_OrganizationUserDetailsPage/path/path';
import { getMasterAdminBillingEventsPath } from '@/bundle/_MasterAdmin/_BillingPage/_BillingEventsPage/path/path';
import { BillingEventsPage } from '@/bundle/_MasterAdmin/_BillingPage/_BillingEventsPage/BillingEventsPage';
import { BillingPageProtectedRoute } from '../_BillingPage/BillingPageProtectedRoute';
import { DevelopersPageProtectedRoute } from '@/bundle/_MasterAdmin/_DevelopersPage/DevelopersPageProtectedRoute';
import { getDevelopersPath } from '@/bundle/_MasterAdmin/_DevelopersPage/path/path';
import { DevelopersPage } from '@/bundle/_MasterAdmin/_DevelopersPage/DevelopersPage';

export const MasterAdminRoutes = [
  <Route
    key={getMasterAdminOrganizationDetailsPath()}
    path={getMasterAdminOrganizationDetailsPath()}
    element={<OrganizationDetailsPage />}
  />,
  <Route
    key={getMasterAdminOrganizationUserDetailsPath()}
    path={getMasterAdminOrganizationUserDetailsPath()}
    element={<OrganizationUserDetailsPage />}
  />,
  <Route key='billing-pages' element={<BillingPageProtectedRoute />}>
    <Route key={getMasterAdminBillingPath()} path={getMasterAdminBillingPath()} element={<BillingPage />} />,
    <Route
      key={getMasterAdminBillingEventsPath()}
      path={getMasterAdminBillingEventsPath()}
      element={<BillingEventsPage />}
    />
    ,
  </Route>,
  <Route element={<DevelopersPageProtectedRoute />}>
    <Route key={getDevelopersPath()} path={getDevelopersPath()} element={<DevelopersPage />} />
  </Route>,
];
